import { VersionedUserData } from '../../../versioned-user-data';
import { ReusablePaymentMethodIdentifier } from './reusable-payment-method-identifier';

export interface ReusablePaymentMethodBackendIdentifier extends ReusablePaymentMethodIdentifier, VersionedUserData {}
